// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!./node_modules/vue-style-loader!./node_modules/css-loader??ref--6-2!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/lib??ref--6-3!./node_modules/vue-loader/lib??vue-loader-options!./src/views/AccountDetail.vue?vue&type=style&index=0&id=4b3a50bc&prod&scoped=true&lang=css&
// module id = vCGZ
// module chunks = 1